import styled, { createGlobalStyle } from 'styled-components';
import { maxWidth } from 'config/constants';

export const HelperModalGlobalStyle = createGlobalStyle`
  .helper-modal {
    .ant-modal .ant-modal-content {
      padding: 20px 0;

      ${maxWidth.l} {
        padding: 40px 0;
      }
    }

    .ant-modal-title {
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_4}px;
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      margin-bottom: ${(props): string => props.theme.kcc.spacing.BASE};
    }

    .helper-modal__close-icon {
      width: 24px;
      height: 24px;
    }

    ${maxWidth.l} {
      .ant-modal {
        width: 100vw !important;
        max-width: 100vw !important;
        margin: 0 !important;
        top: 0 !important;
        padding-bottom: 0 !important;
      }

      .ant-modal-content {
        min-height: 100svh;
        border-radius: 0 !important;
        display: flex;
        flex-direction: column;
      }

      .ant-modal-body {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding: 0;
      }
    }
  }
`;

export const StyledHelperModal = styled.div`
  ${maxWidth.l} {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .helper-modal__scroll-content {
    padding: 0 20px;

    ${maxWidth.l} {
      flex: 1;
      overflow-y: auto;
    }
  }

  .helper-modal__desktop-upload {
    ${maxWidth.l} {
      display: none;
    }
  }

  .helper-modal__mobile-upload {
    display: none;

    ${maxWidth.l} {
      display: block;
    }

    .ant-upload,
    .ant-upload-select {
      display: block;
      width: 100%;
    }
  }

  .helper-modal__take-photo-btn.ant-btn {
    height: 48px;
    border: 2px solid ${(props): string => props.theme.kcc.colors.BLACK};
    border-radius: ${(props): number => props.theme.kcc.borderRadius.PILL}px;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};

    .ant-btn-icon svg {
      width: 20px;
      height: 20px;
    }

    .svg-icon {
      display: flex;
    }
  }

  .helper-modal__take-photo-hint {
    margin: 6px 0 0 0;
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
  }

  .helper-modal__info-alert {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: ${(props): string => props.theme.kcc.colors.BLUE[50]};
    padding: ${(props): string => props.theme.kcc.spacing.SM} ${(props): string => props.theme.kcc.spacing.MD};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.LG};

    .helper-modal__info-alert-icon {
      display: flex;
      width: 24px;
      height: 24px;

      svg {
        width: 24px;
        height: 24px;
      }

      path {
        fill: ${(props): string => props.theme.kcc.colors.INFO};
      }
    }

    p {
      margin: 0;
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    }
  }

  .helper-modal__columns {
    display: flex;
    align-items: flex-start;
    gap: 0;

    ${maxWidth.l} {
      flex-direction: column;
    }
  }

  .helper-modal__column {
    flex: 1;
    min-width: 0;

    ${maxWidth.l} {
      width: 100%;
    }
  }

  .helper-modal__column-title {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XS};
  }

  .helper-modal__upload-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed ${(props): string => props.theme.kcc.colors.BORDER_SECONDARY};
    border-dashes: 4, 4;
    border-radius: 24px;
    padding: ${(props): string => props.theme.kcc.spacing.BASE};
    cursor: pointer;
    background: ${(props): string => props.theme.kcc.colors.BG_CONTAINER};
    text-align: center;
    min-height: 144px;

    &:hover {
      border-color: ${(props): string => props.theme.kcc.colors.GRAY_500};
    }

    .helper-modal__upload-icon {
      width: 48px;
      height: 48px;
      margin-bottom: ${(props): string => props.theme.kcc.spacing.BASE};
    }

    .helper-modal__upload-text {
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
      margin: 0 0 ${(props): string => props.theme.kcc.spacing.XXS} 0;
    }

    .helper-modal__upload-hint {
      color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
      margin: 0;
    }
  }

  .helper-modal__file-preview {
    display: flex;
    align-items: center;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
    border: 2px solid ${(props): string => props.theme.kcc.colors.BLACK};
    border-radius: 24px;
    padding: ${(props): string => props.theme.kcc.spacing.XS} ${(props): string => props.theme.kcc.spacing.MD};
    height: 64px;
  }

  .helper-modal__mobile-photo-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .helper-modal__mobile-photo-image {
    max-height: 208px;
    max-width: 100%;
    margin-bottom: ${(props): string => props.theme.kcc.spacing.BASE};
  }

  .helper-modal__file-thumbnail {
    width: 48px;
    height: 48px;
    object-fit: cover;
  }

  .helper-modal__file-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .helper-modal__file-name {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .helper-modal__file-size {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.SM}px;
  }

  .helper-modal__upload-error-container {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .helper-modal__upload-error-icon {
    width: 12px;
    height: 12px;

    svg {
      width: 12px;
      height: 12px;
    }

    path {
      fill: ${(props): string => props.theme.kcc.colors.ERROR};
    }
  }

  .helper-modal__upload-error {
    margin: 6px 0 0 0;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.SM}px;
    color: ${(props): string => props.theme.kcc.colors.ERROR};
  }

  .helper-modal__file-remove {
    width: 32px;
    height: 32px;
  }

  .helper-modal__file-remove .ant-btn-icon {
    padding-top: ${(props): string => props.theme.kcc.spacing.XXS};
  }

  .helper-modal__or-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 17px;
    align-self: center;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;

    ${maxWidth.l} {
      padding: ${(props): string => props.theme.kcc.spacing.LG} 0;
      width: 100%;
    }
  }

  .helper-modal__select.ant-select {
    width: 100%;
  }

  .helper-modal__divider {
    border: none;
    border-top: 2px solid ${(props): string => props.theme.kcc.colors.BORDER};
    margin: ${(props): string => props.theme.kcc.spacing.BASE} 0;

    ${maxWidth.l} {
      margin: ${(props): string => props.theme.kcc.spacing.LG} 0;
    }
  }

  .helper-modal__device-name-label {
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XS};
    display: block;

    .helper-modal__optional {
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.REGULAR};
      color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
      margin-left: ${(props): string => props.theme.kcc.spacing.XXS};
    }
  }

  .helper-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: ${(props): string => props.theme.kcc.spacing.BASE};
    margin-top: ${(props): string => props.theme.kcc.spacing.LG};
    padding-inline: ${(props): string => props.theme.kcc.spacing.MD};

    ${maxWidth.l} {
      border-top: 2px solid ${(props): string => props.theme.kcc.colors.BORDER};
      margin-top: 0;
      padding-top: ${(props): string => props.theme.kcc.spacing.BASE};
    }

    ${maxWidth.m} {
      justify-content: stretch;
      flex-direction: column;
    }

    .ant-btn > span {
      font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    }

    .helper-modal__cancel-btn.ant-btn {
      border: 2px solid ${(props): string => props.theme.kcc.colors.BLACK};
      font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
      padding: ${(props): string => props.theme.kcc.spacing.XS} ${(props): string => props.theme.kcc.spacing.LG};

      ${maxWidth.m} {
        flex: 1;
        height: 48px;
      }
    }

    .helper-modal__confirm-btn.ant-btn {
      padding: ${(props): string => props.theme.kcc.spacing.XS} ${(props): string => props.theme.kcc.spacing.BASE};
      border: none;

      ${maxWidth.m} {
        flex: 1;
        height: 48px;
      }

      &:disabled {
        background-color: ${(props): string => props.theme.kcc.colors.WHITE};
        color: ${(props): string => props.theme.kcc.colors.TEXT_DISABLED};
        font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
      }
    }
  }
`;
